import { useEffect } from 'react';
import { useParams } from 'react-router-dom';
import ConfiguratorViewer from '../components/ConfiguratorViewer/ConfiguratorViewerV2';
import SmartObjectViewer from '../pages/smartobjectviewer';
import { CONFIGURATOR_UUID } from '../helpers/configData';

const ProductPage = ({
  productsData,
  viewerData,
  setViewerData,
  loadProductsData,
}) => {
  const { uuid } = useParams();
  const isConfiguratorUuid = CONFIGURATOR_UUID.includes(uuid);

  useEffect(() => {
    if (!isConfiguratorUuid && productsData.length === 0) {
      loadProductsData?.();
    }
  }, [isConfiguratorUuid, productsData.length, loadProductsData]);

  if (isConfiguratorUuid) {
    return <ConfiguratorViewer />;
  }

  if (productsData.length === 0) {
    return null;
  }

  return (
    <SmartObjectViewer
      viewerData={viewerData}
      setViewerData={setViewerData}
    />
  );
};

export default ProductPage;
